const ActionCell = (props) => {
    const { data = {
        shouldVisible: false,
        positions: { top: 0, right: 0 },
        rowData: {}
    }, onClose = () => { }, options = [] } = props;
    if (data && data.shouldVisible) {
        return (
            <>
                <div className="action-cell-container">
                    <div className="position-relative h-100 w-100">
                        <span className="action-cell-overlay" onClick={onClose}></span>
                        <ul className="action-cell-options dropdown-menu show" style={{ top: `${data?.positions?.top + 36}px`, right: `${data?.positions?.right - 22}px`, left: "auto" }}>
                            {
                                options?.map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <button
                                                className="dropdown-item"
                                                type="button"
                                                onClick={() => {
                                                    onClose();
                                                    item.onClick(data?.rowData, item?.value, item?.metadata);
                                                }}
                                            >
                                                {item.label}
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </>
        );
    }
    return null;
};

export default ActionCell;